import AuthModalContainer from "./components/organisms/AuthModalContainer";
import { AuthModalContextProvider } from "./contexts/AuthModalContext";

interface IAuthModalProps {
  showLoginModal: boolean;
}
const AuthModal = ({ showLoginModal }: IAuthModalProps) => {
  return (
    <AuthModalContextProvider>
      <AuthModalContainer showLoginModal={showLoginModal} />
    </AuthModalContextProvider>
  );
};

export default AuthModal;
